import api from '../api'

const state = {
  all: [],
  clientInvoices: [],
  loading: false,
  invoice: null
}

const actions = {
  getInvoices: ({ state, commit }, getAll = 0) => {
    return api.getAllInvoices(getAll).then(invoices => {
      return commit('setAllInvoices', invoices)
    })
  },
  getClientInvoices: ({ state, commit }, id) => {
    return api.getAllClientInvoices(id).then(invoices => {
      return commit('setAllClientInvoices', invoices)
    })
  },
  getInvoice: ({ state, commit }, id) => {
    return api.getSingleInvoice(id).then(invoice => {
      return commit('setSingleInvoice', invoice)
    })
  },
  addAdjustment: ({ state, commit }, data) => {
    return api.addInvoiceAdjustment(data)
  },
  updateAdjustment: ({ state, commit }, data) => {
    return api.updateInvoiceAdjustment(data)
  },
  deleteAdjustment: ({ state, commit }, id) => {
    return api.deleteInvoiceAdjustment(id)
  },
  updateInvoice: ({ state, commit }, update) => {
    return api.updateSingleInvoice(update)
  },
  uploadFile: ({ state, commit }, data) => {
    return api.uploadSingleInvoiceFile(data)
  }

}

const mutations = {
  setAllInvoices (state, invoices) {
    state.all = invoices
  },
  setAllClientInvoices (state, invoices) {
    state.clientInvoices = invoices
  },
  setSingleInvoice (state, invoice) {
    state.invoice = invoice
  },
  setStartLoading (state) {
    state.loading = true
  },
  setFinishLoading (state) {
    state.loading = false
  }
}

const getters = {
  all: state => {
    return state.all
  },
  clientInvoices: state => {
    return state.clientInvoices
  },
  invoice: state => {
    return state.invoice
  },
  loading: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js